import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

import {
  setLocalStorage,
  getLocalStorage,
  clearLocalStorage,
} from '../../../utils/storageUtil';

const CancelModel = ({ open, toggle, history, to }) => {
  return (
    <div>
      {open && (
        <Modal
          open={open}
          onClose={toggle}
          center
          classNames={{
            modal: 'cancel-modal',
          }}
        >
          <div className="terms-condition">
            <div style={{ display: 'flex' }}>
              <div className="col-sm-8" style={{ paddingBottom: '5px' }}>
                <h3
                  className="cancel-modal-title"
                  style={{ paddingLeft: '13px' }}
                >
                  Are you sure ?
                </h3>
              </div>
            </div>
            <div className="pt-3 pr-3">
              <div className="col-auto" style={{ textAlign: 'right' }}>
                <button
                  onClick={() => {
                    clearLocalStorage('mobile');
                    clearLocalStorage('requestId');
                    clearLocalStorage('fullName');
                    clearLocalStorage('registrationEmail');
                    toggle();
                    history.push(to);
                  }}
                  className={'btn btn-primary btn-width btn-white mr-2'}
                >
                  Yes
                </button>
                <button
                  onClick={toggle}
                  className={'btn btn-primary btn-width btn-white'}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CancelModel;
